// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"DocumentGrid_gridContainer__19vli","gridOverlay":"DocumentGrid_gridOverlay__3fvcD"};